(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rdv-product-description"] && !Shopify.designMode) return;
  try {
    (() => {
    const supplierReferencePattern = /(?:r[eé]f[eé]rence\s+(?:fournisseur|interne)|sku\s*(?:fournisseur|interne)?|code\s+(?:interne|d['’]import))\s*:/i;
    const compliancePattern = /(?:fabricant|op[eé]rateur\s+[eé]conomique|personne\s+responsable\s+(?:ue|u\.e\.)|responsable\s+(?:ue|u\.e\.))/i;
    const phoneLabelPattern = /(?:\s*[—–-]\s*)?(?:t[eé]l(?:[eé]phone)?\.?\s*:\s*)?\+?\d[\d\s().-]{7,}\d\s*\.?\s*$/i;

    const plainText = (html) => {
      const parser = document.createElement('div');
      parser.innerHTML = html;
      return parser.textContent.trim();
    };

    const withoutSupplierReference = (html) => {
      const text = plainText(html);
      const match = text.match(supplierReferencePattern);
      if (!match) return html;

      const visiblePrefix = text.slice(0, match.index).trim();
      return visiblePrefix;
    };

    const withoutOptionalPhone = (html) => {
      const text = plainText(html).replace(phoneLabelPattern, '').trim();
      return text;
    };

    const processDescription = (root) => {
      if (root.dataset.rdvProcessed === 'true') return;
      root.dataset.rdvProcessed = 'true';

      const commercial = root.querySelector('[data-rdv-commercial-description]');
      const disclosure = root.querySelector('[data-rdv-compliance]');
      const complianceContent = root.querySelector('[data-rdv-compliance-content]');
      if (!commercial || !disclosure || !complianceContent) return;

      const candidates = commercial.querySelectorAll('p, li');
      const elements = candidates.length ? [...candidates] : [commercial];
      const complianceLines = [];

      elements.forEach((element) => {
        const fragments = element.innerHTML.split(/<br\s*\/?\s*>/i);
        const commercialFragments = [];

        fragments.forEach((fragment) => {
          const text = plainText(fragment);
          if (!text) return;

          if (compliancePattern.test(text)) {
            const cleanRegulatoryLine = withoutOptionalPhone(withoutSupplierReference(fragment));
            if (cleanRegulatoryLine) complianceLines.push(cleanRegulatoryLine);
            return;
          }

          if (supplierReferencePattern.test(text)) return;
          commercialFragments.push(fragment);
        });

        if (element === commercial) {
          element.innerHTML = commercialFragments.join('<br>');
        } else if (commercialFragments.length) {
          element.innerHTML = commercialFragments.join('<br>');
        } else {
          element.remove();
        }
      });

      if (!complianceLines.length) return;

      complianceLines.forEach((line) => {
        const paragraph = document.createElement('p');
        paragraph.textContent = line;
        complianceContent.appendChild(paragraph);
      });
      disclosure.hidden = false;
    };

    document.querySelectorAll('[data-rdv-product-description]').forEach(processDescription);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-rdv-product-description]').forEach(processDescription);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
